import React from 'react';
import { Profile } from 'oidc-client';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { RouteParams } from '../../core/models/RouteHelper';
import MatchLog from './MatchLog';
import ValidationWindow from './ValidationWindow';

interface OwnProps {
    userProfile?: Profile;
}

export type Props = OwnProps & RouteComponentProps<RouteParams>;

const MatchLogRoute = (props: Props): React.ReactElement =>
    React.createElement(ValidationWindow, { matchId: Number(props.match.params.matchId), key: props.match.params.matchId,
        children: React.createElement(MatchLog, props) });

export default withRouter(MatchLogRoute);
